import type { Language } from "@app/constants";

interface Messages {
	currencyCode: string;
	defaultValue: string;
	groupSeparator: string;
	heading: string;
	headingDesktop: string;
	investedAmount: string;
	netProfit: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		currencyCode: "R ",
		defaultValue: "-",
		groupSeparator: ",",
		heading: "Trade",
		headingDesktop: "Trade Status",
		investedAmount: "Invested Amount:",
		netProfit: "Net Profit:",
	},
};

export default messages;
